export default __webpack_public_path__ + "static/img_big-764b81761e517e4128cd56b3eb9c5571.png";